import { startRegistration } from "@simplewebauthn/browser";

export function FormRegistrazione() {
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const nome = formData.get("nome");
    const username = formData.get("username");

    if (!nome || nome.toString().trim() === "") {
      alert("Il nome della passkey è obbligatorio.");
      return;
    }

    if (!username || username.toString().trim() === "") {
      alert("L'username è obbligatorio.");
      return;
    }

    const result = await fetch("/api/start", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: username.toString(),
        nominativo: nome.toString(),
      }),
    });

    if (result.status < 200 || result.status >= 300) {
      const errorData = await result.json();
      alert(JSON.stringify(errorData));
      return;
    }

    const { idChallenge, options } = await result.json();

    let attResp;
    try {
      // Pass the options to the authenticator and wait for a response
      attResp = await startRegistration({ optionsJSON: options });
    } catch (error: any) {
      // Some basic error handling
      if (error.name === "InvalidStateError") {
        alert("Error: Authenticator was probably already registered by user");
      } else {
        alert(JSON.stringify(error));
      }

      throw error;
    }

    const verificationResp = await fetch("/api/complete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ idChallenge, risposta: attResp }),
    });

    // Wait for the results of verification
    const verificationJSON = await verificationResp.json();

    console.log(verificationJSON);

    // Show UI appropriate for the `verified` status
    if (verificationResp.status >= 200 && verificationResp.status < 300) {
      alert(
        `Congratulazioni! La tua passkey è stata registrata con successo. ${JSON.stringify(verificationJSON)}`,
      );
    } else {
      alert(
        `Oh no, something went wrong! Response: ${JSON.stringify(
          verificationJSON,
        )}`,
      );
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        className="input"
        type="text"
        name="nome"
        placeholder="Nome della passkey"
      />
      <input
        className="input"
        type="text"
        name="username"
        placeholder="Username"
      />
      <button className="send-button" type="submit">
        Registra PassKey
      </button>
    </form>
  );
}
